import { RouteComponentProps, withRouter, Redirect } from "react-router";
import * as React from "react";
import { BPM_LOGO_SVG } from "../assets";
import { NewReleases } from "src/pages/NewReleases";
import { TopDownloads } from "src/pages/TopDownloads";
import { SearchResults } from "src/pages/SearchResult";
import Account from "./Account";
import { PlaybackState, PlayerState, Crate, PlaybackManager, HQ_KEY, HeaderTabConfig, BPMCrate, AudioVideoDefaultProps, Loader, ThemeContextProvider, PlayerContextProvider, UserContextProvider, Header, withToast, WithToast, CrateContextProvider, errorToString, BPMMedia, Player, ContentType, ListviewInteractionProps, BPMUser, ListView } from 'bpm-web-generic';
import { CrateManager } from "src/manager/CrateManager";
import Popup from "src/components/views/Popup";
import { ArtistReleasess } from "src/pages/ArtistReleases";
import { ThemeProvider } from "@material-ui/styles";
import { createMuiTheme, LinearProgress } from "@material-ui/core";
import { GenreView } from "src/pages/Genres";
import * as moment from "moment"
import { User, SubscriptionInfo, APIError, APIErrorType, UsersAPI, Session, InvalidSubscriptionError } from "bpm-client-api";
import { Browse } from "src/pages/Browse";
import { ScratchToolsView } from "src/pages/ScratchTools";
import Playlists from "src/pages/Playlists";
import CuratedSet from "src/pages/CuratedSet";
import { downloadOrCrateMessageHandler } from "src/manager/errormessagehandler";
import { Analytics } from "src/manager/AnalyticsManager";
import { Live } from "src/pages/Live";
import { Share } from "src/pages/Share";
import { Environment } from "src/env";
import { MembershipInfo } from "bpm-client-api/lib/endpoints/user";
import { mediaAPI } from "src/api/config";
import { IdPlayBody } from "src/api/download-api-sdk/src";
import { BPMRedirect } from "src/components/BPMRedirect";
import ClassicModeBanner from "src/components/classic-mode-banner";

export interface MainState {
    theme: 'black' | 'white',
    membershipInfo?: MembershipInfo,
    user?: User,
    player: {
        state: PlaybackState
    },
    crate: BPMCrate
    membership_type: SubscriptionInfo | string
    membership_expired?: boolean
    loading: boolean
    initialLoading: boolean
}

export function downloadMedia(media: BPMMedia, crate: boolean) {
    if (document.body.classList.contains('mobile')) {
        return Promise.reject()
    }
    return mediaAPI.getDownloadUrl(media.id as number, location.pathname, 'music', crate ? '1' : '0').then(({ data: info }) => {
        try {
            window.location.assign(info!.url)
        } catch (error) {

        }
        if (crate) {
            CrateManager.instance().removeFromCrateLocal(media)
        }
        return true;
    }).catch((err: APIError) => {
        if (err.type == APIErrorType.DownloadLimitReachedError) {
            Popup.downloadLimitExceeded()
        } else {
            throw err
        }
        return false;
    })
}
class Main extends React.Component<RouteComponentProps<{ page: string }> & WithToast, MainState> {

    constructor(props: any) {
        super(props);
        this.state = {
            theme: 'black',
            player: {
                state: {
                    state: PlayerState.None
                }
            }, crate: [], membership_type: SubscriptionInfo.None, loading: false, initialLoading: true
        }
        PlaybackManager.getPlaybackInfo = (mediaId: number, duration: number) => {
            return mediaAPI.reportMediaPlay(mediaId, {
                from_location: location.pathname,
                from_library: IdPlayBody.FromLibraryEnum.Music,
                duration: duration
            }).then(() => {

            })
        }
        PlaybackManager.getInstance().addPlaybackStateListener((state: PlaybackState) => {
            const player = Object.assign({}, this.state.player)
            player.state = state;
            this.setState({ player })
        })
        Player.checkHQMiddleware = UsersAPI.setHQ as unknown as (() => Promise<void>)
        CrateManager.instance().addListener('crate-loaded', (crate: BPMCrate) => {
            this.setState({ crate })
        })
        ListView.BPM_ICON = BPM_LOGO_SVG
    }

    componentDidMount() {
        UsersAPI.getMembership('music').then((info) => {
            this.setState({ membershipInfo: info, loading: false })
        }).catch((err) => {
            this.setState({ loading: false })
        })
        this.loadUser()
        PlaybackManager.getInstance().addPlaybackStateListener((state) => {
            if (state.state == PlayerState.Error) {
                this.props.showToast('danger', 'Unable to play track. Please try again later.')
            }
        })
        Session.setUserUpdatedHandler((user) => {
            this.setState({ user, theme: user.theme })
        })
        CrateManager.instance().loadCrate()
        document.addEventListener("fullscreenchange", () => {
            this.forceUpdate()
        });
        document.addEventListener("mozfullscreenchange", () => {
            this.forceUpdate()
        });
        document.addEventListener("webkitfullscreenchange", () => {
            this.forceUpdate()
        });
        document.addEventListener("msfullscreenchange", () => {
            this.forceUpdate()
        });
        Analytics.trackView()
    }

    componentDidUpdate(prevProps: RouteComponentProps) {
        if (prevProps.location.pathname != this.props.location.pathname) {
            Analytics.trackView()
        }
    }

    private loadUser() {
        UsersAPI.getMev2().then(({ user, membership }) => {
            if (window.bugsnagClient) {
                window.bugsnagClient.user = {
                    id: user.id,
                    email: user.email,
                    name: user.full_name
                }
            }
            if (user.theme == 'black') {
                document.body.classList.add('theme-black')
            }
            if (user.is_admin) {
                jiraHelpdesk(function () {
                    var DOMContentLoaded_event = document.createEvent('Event');
                    DOMContentLoaded_event.initEvent('DOMContentLoaded', true, true);
                    window.document.dispatchEvent(DOMContentLoaded_event);
                });
            }
            PlaybackManager.getInstance().storeHQConfig = false
            if (PlaybackManager.getInstance().hq && user.hq_allowed == false) {
                PlaybackManager.getInstance().hq = false;
            } else if (localStorage[HQ_KEY] == undefined && user.hq_allowed) {
                PlaybackManager.getInstance().hq = true;
            }
            PlaybackManager.getInstance().storeHQConfig = true
            if (membership && (membership.order as any).library != 'latin') {
                this.setState({ membership_type: membership.membership_info, initialLoading: false })
            } else {
                UsersAPI.getMembershipv2('music').catch((err: APIError) => {
                    if (err.type == APIErrorType.InvalidSubscriptionError) {
                        if ((err as InvalidSubscriptionError).had_subscription) {
                            this.setState({ membership_expired: true, initialLoading: false, membership_type: SubscriptionInfo.None })

                            const oldDate = new Date(localStorage.getItem('expired_membership_last_shown') || 0).getTime()
                            const currentDate = new Date().getTime()
                            const oneWeek = (7 * 24 * 60 * 60 * 1000)

                            if ((currentDate - oldDate) > oneWeek) {
                                localStorage.setItem('expired_membership_last_shown', new Date().toJSON())
                                return Popup.expiredMembership().then((val) => {
                                    if (val === 'ok') {
                                        this.props.history.push('/account/subscription/1')
                                    }
                                })
                            }
                        }
                        else {
                            this.setState({ membership_expired: false, membership_type: SubscriptionInfo.None, initialLoading: false })
                        }
                    } else {
                        this.setState({ membership_expired: false, membership_type: SubscriptionInfo.None, initialLoading: false })
                    }
                })
            }
        }).catch((err: APIError) => {
            if (err.status == 429) {
                setTimeout(() => {
                    this.loadUser()
                }, 5100)
            } else {
                // ToDo
            }
        })
    }

    private getPages(): (HeaderTabConfig & { props?: any })[] {
        return [{
            title: 'Browse',
            path: 'browse',
            icon_height: 0,
            component: Browse,
            props: {
                membership: this.state.membership_type,
                membershipExpired: this.state.membership_expired
            }
        }, {
            title: 'New Releases',
            path: 'new-releases',
            icon_height: 0,
            component: NewReleases
        }, {
            title: 'Trends',
            path: 'trends',
            icon_height: 0,
            component: TopDownloads
        },
        {
            title: 'Playlists',
            path: 'playlists',
            icon_height: 0,
            component: Playlists
        },
        {
            title: 'Curated Sets',
            path: 'curated-sets',
            icon_height: 0,
            component: CuratedSet
        },
        {
            title: 'Scratch Tools',
            path: 'scratch-tools',
            icon_height: 0,
            component: ScratchToolsView
        }, {
            title: 'Genres',
            path: 'genres',
            icon_height: 0,
            component: GenreView
        }/*, {
            title: 'BPM TV',
            path: 'bpmtv',
            icon_height: 0,
            component: Live
        }*/]
    }
    private getMainComponent(page: string): [React.ComponentClass<AudioVideoDefaultProps & ListviewInteractionProps>, any?] {
        let config = this.getPages().find(t => t.path == page)
        if (config) {
            return [config.component, config.props]
        }
        const self = this
        switch (page) {
            case 'search':
                return [SearchResults];
            case 'account':
                return [Account];
            case 'top-downloads':
            case 'featured':
                return [TopDownloads]
            case 'top-downloads':
                return [TopDownloads]
            case 'upgrade':
            case 'subscribe':
                return [BPMRedirect as any, { to: `${Environment.NEW_POOL_URL}/d/account/plan` }]
            case 'crate':
                return [Crate as any, {
                    onDownload: (type: ContentType | 'all', category: string) => {
                        return CrateManager.instance().downloadCrate(type, category)
                    },
                    onClear: (type: ContentType | 'all', category: string) => {
                        return CrateManager.instance().clearCrate(type, category).then(() => {
                            return true
                        }).catch(err => {
                            return false
                        })
                    }
                }]
            case 'artist':
                return [ArtistReleasess];
            case 'live':
                return [Live]
            case 'share':
                return [Share]
            case 'genres':
                return [GenreView]
            default:
                return [Redirect as any, { to: '/' }]
        }
    }

    private removeFromCrate(media: BPMMedia) {
        Analytics.trackClick('remove_from_crate_media', media.id.toString())
        return CrateManager.instance().removeFromCrate(media).then(() => {
            return true
        })
    }

    private addToCrate(media: BPMMedia, config?: any) {
        Analytics.trackClick('add_to_crate_media', media.id.toString())
        return CrateManager.instance().addToCrate(media).then(() => {
            return true
        }).catch(err => {
            downloadOrCrateMessageHandler(err, config, this)
            return false
        })
    }

    public render() {
        const [Comp, extraProps] = this.getMainComponent(this.props.match.params.page)
        if (this.state.initialLoading) {
            return <div style={{ paddingTop: '20%' }}>
                <Loader size={80} />
            </div>
        }
        return (
            <PlayerContextProvider value={{ track: this.state.player.state.media, state: this.state.player.state.state }}>
                <ThemeContextProvider value={this.state.theme}>
                    <ThemeProvider theme={createMuiTheme({
                        palette: {
                            primary: {
                                main: '#f73e00'
                            }
                        }
                    })}>
                        <UserContextProvider value={this.state.user! as unknown as BPMUser}>
                            <CrateContextProvider value={this.state.crate}>
                                <video id='bpmlive' autoPlay controls playsInline muted
                                    style={{
                                        visibility: 'hidden',
                                        top: 0, left: 0, width: 0,
                                        height: 0, position: 'absolute'
                                    }}
                                />
                                <Player usePip={false} onAddToCrate={(media, config) => {
                                    return this.addToCrate(media, config)
                                }} onRemoveFromCrate={(media) => {
                                    return this.removeFromCrate(media)
                                }} onMediaDownlod={(media, crate, config) => downloadMedia(media, crate).catch(err => {
                                    downloadOrCrateMessageHandler(err, config, this)
                                    return false
                                })} onArtistClick={(type: ContentType, artist: string) => {
                                    this.props.history.push(`/artist/${type}/${encodeURIComponent(artist)}`)
                                }} onPreviewtrackEnded={(target) => {
                                    if (this.state.user!.verification_status == 'verified') {
                                        if (this.state.membership_type == SubscriptionInfo.None) {
                                            target.setAttribute('data-balloon', 'Get access. Purchase a membership.')
                                            target.setAttribute('data-balloon-visible', '')
                                            target.setAttribute('data-balloon-pos', 'up')
                                            target.classList.add('player-balloon')
                                        }
                                    } else if (this.state.user!.verification_status != 'pending') {
                                        target.setAttribute('data-balloon', 'Get full access. Request a membership now.')
                                        target.setAttribute('data-balloon-visible', '')
                                        target.setAttribute('data-balloon-pos', 'up')
                                        target.classList.add('player-balloon')
                                    } else {
                                        target.setAttribute('data-balloon', 'Your membership request is under review.')
                                        target.setAttribute('data-balloon-visible', '')
                                        target.setAttribute('data-balloon-pos', 'up')
                                        target.classList.add('player-balloon')
                                    }
                                }} />
                                <div style={WrapperStyle}>
                                    <div style={{ flex: 1, maxWidth: '100%' }}>
                                        <ClassicModeBanner
                                            platform="BPM Supreme"
                                            href="https://app.bpmsupreme.com"
                                        />
                                        <Header
                                            membershipType={
                                                this.state.membershipInfo &&
                                                this.state.membershipInfo.membership_type
                                            }
                                            membershipExpired={
                                                this.state.membership_expired &&
                                                this.state.membership_expired
                                            } onMembershipChangeClick={() => {
                                                this.props.history.push('/account/subscription/1')
                                            }}
                                            isFullScreen={(document as any).webkitIsFullScreen || (document as any).msFullscreenElement || document.fullscreen}
                                            user={{ theme: this.state.theme }}
                                            pages={this.getPages()} onLogout={() => {
                                                UsersAPI.logout().finally(() => {
                                                    window.location.assign(Environment.POOL_URL + '/login');
                                                })
                                            }} onLogoClick={() => {
                                                this.props.history.push('/')
                                            }} onNavigateToCrate={() => {
                                                this.props.history.push('/crate')
                                            }} onBPMCreateClick={() => {
                                                window.open(process.env.REACT_APP_ENV === 'production' ? 'https://create.bpmsupreme.com' : 'https://develop.bpmcreate.com')
                                            }} onBPMLatinoClick={() => {
                                                window.open(process.env.REACT_APP_ENV === 'production' ? 'https://latino.bpmsupreme.com' : 'https://dev.latino.bpmsupreme.com')
                                            }} onEnterFullScreen={(document.fullscreenEnabled || (document as any).webkitFullscreenEnabled ||
                                                (document as any).mozFullScreenEnabled ||
                                                (document as any).msFullscreenEnabled) ? () => {
                                                    var docElm = document.documentElement;
                                                    if ((document as any).webkitIsFullScreen || (document as any).msFullscreenElement || document.fullscreen) {
                                                        try {
                                                            if (document.exitFullscreen) {
                                                                document.exitFullscreen();
                                                            }
                                                            else if ((document as any).mozCancelFullScreen) {
                                                                (document as any).mozCancelFullScreen();
                                                            }
                                                            else if ((document as any).webkitCancelFullScreen) {
                                                                (document as any).webkitCancelFullScreen();
                                                            }
                                                            else if ((document as any).msExitFullscreen) {
                                                                (document as any).msExitFullscreen();
                                                            }
                                                        } catch (error) {

                                                        }
                                                    } else {
                                                        try {
                                                            if (docElm.requestFullscreen) {
                                                                docElm.requestFullscreen();
                                                            }
                                                            else if ((docElm as any).mozRequestFullScreen) {
                                                                (docElm as any).mozRequestFullScreen();
                                                            }
                                                            else if ((docElm as any).webkitRequestFullScreen) {
                                                                (docElm as any).webkitRequestFullScreen();
                                                            }
                                                            else if ((docElm as any).msRequestFullscreen) {
                                                                (docElm as any).msRequestFullscreen();
                                                            }
                                                        } catch (error) {

                                                        }
                                                    }
                                                } : undefined} BPM_LOGO_SVG={BPM_LOGO_SVG}
                                            onSupport={() => {
                                                window.open('https://support.bpmsupreme.com/hc/en-us', '__blank')
                                            }} onContact={() => {
                                                window.location.href = "mailto:info@bpmsupreme.com?subject=Contact";
                                            }} />
                                        <div className="root-content-container">
                                            {this.state.loading &&
                                                <LinearProgress color="secondary" variant="indeterminate" classes={{ colorPrimary: 'barPrimary', barColorPrimary: 'barColorPrimary' }}
                                                    style={{
                                                        margin: 0,
                                                        position: 'absolute',
                                                        top: 0,
                                                        left: 0,
                                                        right: 0,
                                                        zIndex: 999
                                                    }} />}
                                            <div className="root-content">
                                                <Comp {...extraProps} onLoading={(loading: boolean) => {
                                                    this.setState({ loading })
                                                }} onAlbumSelected={(album) => {
                                                }} onMediaSelected={(media, album) => {
                                                }} onMediaDownlod={(media, crate, config) => {
                                                    return downloadMedia(media, crate).catch(err => {
                                                        downloadOrCrateMessageHandler(err, config, this)
                                                        return false
                                                    })
                                                }} onAddToCrate={(media, config) => {
                                                    return this.addToCrate(media, config)
                                                }} onRemoveFromCrate={(media) => {
                                                    return this.removeFromCrate(media)
                                                }} onSpeacialTypeClick={(contentTtype: ContentType, type: 'serato' | 'tr') => {
                                                    if (type == 'serato') {
                                                        this.props.history.push(`/new-releases/classic/${contentTtype}?serato`, { rnd: Math.random() })
                                                    } else {
                                                        this.props.history.push(`/new-releases/classic/${contentTtype}?tr-sync`, { rnd: Math.random() })
                                                    }
                                                }} onArtistClick={(type: ContentType, artist: string) => {
                                                    this.props.history.push(`/artist/${type}/${encodeURIComponent(artist)}`)
                                                }} onGenreClick={(type: ContentType, genre: string) => {
                                                    this.props.history.push(`/new-releases/${type}/genre/${(genre)}`)
                                                }} onCategoryClick={(type: ContentType, category: string) => {
                                                    this.props.history.push(`/new-releases/${type}/${(category)}`)
                                                }} onBPMClick={(type: ContentType, bpm: number) => {
                                                    this.props.history.replace(`/new-releases/classic/${type}?bpm=${(bpm)}`, { rnd: Math.random() })
                                                }} onKeyClick={(type: ContentType, key: string) => {
                                                    this.props.history.push(`/new-releases/classic/${type}?key=${encodeURIComponent(key)}`, { rnd: Math.random() })
                                                }} onDateClick={(type: ContentType, date: Date) => {
                                                    this.props.history.push(`/new-releases/classic/${type}?date=${moment(date).utcOffset(0).format('YYYY-MM-DD')}`, { rnd: Math.random() })
                                                }} onExclusiveClick={(type) => {
                                                    this.props.history.push(`/new-releases/classic/${type}?exclusive=1`, { rnd: Math.random() })
                                                }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </CrateContextProvider>
                        </UserContextProvider>
                    </ThemeProvider>
                </ThemeContextProvider>
            </PlayerContextProvider>
        )
    }
}
export default withToast(withRouter(Main) as any, { position: 'fixed', top: 100, left: 20, right: 20, zIndex: 160 })

const WrapperStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'stretch'
}

function jiraHelpdesk(callback: () => void) {
    var jhdScript = document.createElement('script');
    jhdScript.type = 'text/javascript';
    jhdScript.setAttribute('data-jsd-embedded', '');
    jhdScript.setAttribute('data-key', 'dca400a6-fed7-48cd-a1e6-6cf76ba840c8')
    jhdScript.setAttribute('data-base-url', 'https://jsd-widget.atlassian.com');
    jhdScript.src = 'https://jsd-widget.atlassian.com/assets/embed.js';

    jhdScript.onload = function () {
        callback();
    };
    document.getElementsByTagName('head')[0].appendChild(jhdScript);
}


// WEBPACK FOOTER //
// ./src/layout/Main.tsx